import { render, staticRenderFns } from "./SmsLogin.vue?vue&type=template&id=56ae54eb&scoped=true&"
import script from "./SmsLogin.vue?vue&type=script&lang=js&"
export * from "./SmsLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae54eb",
  null
  
)

export default component.exports